import { useMemo } from 'react';
import isEmpty from 'lodash.isempty';
// this could be done with pages instead of toc
const usePageNavigation = (toc, urlPageId) => {
  return useMemo(() => {
    if (isEmpty(toc)) return { prev: null, next: null };

    let activeSectionIndex, activePageIndex;
    const activeSection = toc.find((section, sectionIdx) => {
      activePageIndex = section.pages.findIndex((page) => page.id === Number(urlPageId));
      if (activePageIndex !== -1) {
        activeSectionIndex = sectionIdx;
        return true;
      }
      return false;
    });

    if (!activeSection) return { prev: null, next: null };

    let prev = null;
    if (activePageIndex > 0) {
      prev = activeSection.pages[activePageIndex - 1];
    } else {
      for (let i = activeSectionIndex - 1; i >= 0; i--) {
        if (toc[i].pages.length > 0) {
          prev = toc[i].pages.at(-1);
          break;
        }
      }
    }

    let next = null;
    if (activePageIndex < activeSection.pages.length - 1) {
      next = activeSection.pages[activePageIndex + 1];
    } else {
      for (let i = activeSectionIndex + 1; i < toc.length; i++) {
        if (!toc[i].isLocked && toc[i].pages.length > 0) {
          next = toc[i].pages[0];
          break;
        }
      }
    }

    return { prev, next };
  }, [toc, urlPageId]);
}

export default usePageNavigation;
